"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.max5ConsecutiveDigits = exports.supportedWordsOnly = exports.supportedCharsOnly = exports.stringPresent = exports.validEmail = void 0;
const merlin_email_input_1 = require("@travelnest/merlin.email-input");
Object.defineProperty(exports, "validEmail", { enumerable: true, get: function () { return merlin_email_input_1.isValid; } });
const stringPresent = (v) => !!v && !!v.trim() && v.trim().length > 0;
exports.stringPresent = stringPresent;
// This matches the smallest supported character set by any of our channels (limited by Expedia)
// See https://www.notion.so/travelnest/Improved-validation-for-Non-latin-characters-in-address-and-listing-headlines-e965041e512f43b78224d664816b4645
const SUPPORTED_CHARS_REGEXP = /^[a-z0-9\-!&,' ]*$/i;
const supportedCharsOnly = (value) => SUPPORTED_CHARS_REGEXP.test(value);
exports.supportedCharsOnly = supportedCharsOnly;
const BANNED_WORDS = ['safe', 'clean', 'sterile'];
const supportedWordsOnly = (value) => !value.split(' ').some(word => BANNED_WORDS.includes(word.toLowerCase()));
exports.supportedWordsOnly = supportedWordsOnly;
const SIX_CONSECUTIVE_DIGITS_REGEXP = /\d{6}/;
const max5ConsecutiveDigits = (value) => !SIX_CONSECUTIVE_DIGITS_REGEXP.test(value);
exports.max5ConsecutiveDigits = max5ConsecutiveDigits;
//# sourceMappingURL=validators.js.map